import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {DeviceAvdbSeries} from "../device-avdb-series";
import {DeviceAvdbType} from "../device-avdb-type";
import {CoverageDetailComponent} from "../shared/coverage-detail.component";
import {IgnoreDatabaseComponent} from "../shared/ignore-database.component";
import {DeviceService} from "../device.service";
import {AvdbTypeRowStatus} from "./avdb-type-row-status";

@Component({
	selector: "avdb-type-row-v1",
	template: `
		<div *ngIf="avdbTypeRowStatus" class="deviceproductrow_info">
			<div class="deviceproductrow_type">
				<div class="deviceproductrow_typeheading">
					<avdb-type-logo class="deviceproductrow_typename" [avdbType]="avdbType"></avdb-type-logo>
					<ng-container *ngIf="avdbType.installedIssue && avdbTypeRowStatus.isIssueVisible">
						<button class="button-link"
								(click)="coverageModal.open(avdbType.installedSeries.region)">
							{{avdbType.installedSeries.region.name}}
						</button>
						— Cycle {{avdbType.installedIssue.name}} <span
							*ngIf="avdbType.installedIssue.versionNumber"> ({{avdbType.installedIssue.versionNumber}}
						)</span>
					</ng-container>
				</div>

				<details class="deviceproductrow_issues" *ngIf="otherInstallableSeries.length > 0"
						 [open]="otherIssuesDefaultOpen">
					<summary class="deviceproductrow_issuesheading">{{otherIssuesHeading}}</summary>
					<ul class="deviceproductrow_issuelist">
						<li *ngFor="let series of otherInstallableSeries">
							<button class="button-link" (click)="coverageModal.open(series.region)">
								{{series.region.name}}
							</button>
							— Cycle {{series.installableIssues[0].name}} <span
								*ngIf="series.installableIssues[0].versionNumber"> ({{series.installableIssues[0].versionNumber}}
							)</span>
                            <span *ngIf="!series.isFree"
                                  class="deviceproductrow_issuelist_remaining">
								<ng-container *ngIf="series.isAutoRenew">
									Auto-renew enabled
								</ng-container>
								<ng-container *ngIf="!series.isAutoRenew && series.expectedEndDate != null">
									Coverage until {{series.expectedEndDate | momentDate}}
								</ng-container>
							</span>
                        </li>
					</ul>
				</details>
			</div>

			<div class="deviceproductrow_status">
				<div class="{{avdbTypeRowStatus.statusColor}}">
					<i *ngIf="avdbTypeRowStatus.hasCheckIcon" class="fa fa-check-circle"></i>
					<i *ngIf="avdbTypeRowStatus.hasExclamationIcon" class="fa fa-exclamation-circle"></i>
					{{avdbTypeRowStatus.statusText}}
				</div>
				<div class="deviceproductrow_statussubtext" *ngIf="avdbTypeRowStatus.statusSubtext">{{avdbTypeRowStatus.statusSubtext}}</div>
				<div *ngIf="avdbTypeRowStatus.isIssueVisible" class="deviceproductrow_statusremaining">
                    <div *ngIf="avdbTypeRowStatus.expectedEndDate && avdbTypeRowStatus.expectedEndDate.isAfter()">Coverage until
						{{avdbTypeRowStatus.expectedEndDate | momentDate}}
					</div>
					<br>
					<button *ngIf="avdbTypeRowStatus.isIgnoreButtonVisible" class="button" (click)="ignoreDatabaseModal.open(deviceService, avdbType.deviceId, avdbType.installedIssue.seriesID)">
						Ignore Database
					</button>
				</div>
			</div>

		</div>
	`,
})
export class AvdbTypeRowV1Component implements OnInit {
	@Input() avdbType: DeviceAvdbType;
	@Input() deviceService: DeviceService;
	@Input() coverageModal: CoverageDetailComponent;
	@Input() ignoreDatabaseModal: IgnoreDatabaseComponent;
	@Input() otherInstallableSeries: Array<DeviceAvdbSeries>;
	@Input() otherIssuesHeading: string;
	@Output() jeppesenLoginButtonClicked = new EventEmitter();

	avdbTypeRowStatus: AvdbTypeRowStatus;

	ngOnInit() {
		this.avdbTypeRowStatus = new AvdbTypeRowStatus(this.avdbType, this.avdbType.installedIssue);
		this.avdbTypeRowStatus.setStatus(this.avdbType.status);
	}

	get otherIssuesDefaultOpen() {
		return this.otherInstallableSeries.length > 0;
	}
}
